module.exports = __webpack_public_path__ + "assets/img/zanwushuju.1f0c809b.png";